import { focusedTarget } from './citationHighlightTargets'

export function citationLocationLabel(citation, targetIndex = -1) {
  if (!citation) return ''
  if (citation.kind === 'web') {
    try {
      return new URL(citation.url).hostname.replace(/^www\./, '')
    } catch {
      return 'Web source'
    }
  }
  if (citation.kind === 'row') {
    const sheet = citation.sheet ?? 'Sheet'
    const rows = citation.rows ?? []
    if (rows.length === 0) return sheet
    if (rows.length === 1) return `${sheet}!row ${rows[0]}`
    return `${sheet}!rows ${rows[0]}-${rows[rows.length - 1]}`
  }
  if (citation.kind === 'section') {
    const sectionPath = Array.isArray(citation.section_path)
      ? citation.section_path.join(' > ')
      : citation.section_path
    return sectionPath || (citation.page ? `Page ${citation.page}` : 'Section')
  }
  const page = focusedTarget(citation, targetIndex)?.page ?? citation.page
  return page ? `Page ${page}` : 'Document'
}

/** True when this occurrence's own evidence is what failed to resolve. */
export function isTargetFlagged(citation, targetIndex) {
  return Boolean(citationLocationStatus(citation, targetIndex))
}

export function citationDocTitle(citation) {
  return citation?.title || citation?.file_name || citation?.doc_id || 'Source'
}

export function isFlagged(citation) {
  return ['partial', 'coarse', 'failed'].includes(citation?.span_resolution)
}

export function citationLocationStatus(citation, targetIndex = -1) {
  const resolution =
    focusedTarget(citation, targetIndex)?.resolution ??
    citation?.span_resolution
  if (resolution === 'coarse') return 'approximate location'
  if (resolution === 'partial') return 'some locations unverified'
  if (resolution === 'failed') return 'location unavailable'
  return null
}
